class GiftQuote {
  constructor() {
    this.wrapper = document.getElementById("gift-quote-page");
    const _this = this;
    if (this.wrapper) {
      this.physicalExtra = 3;

      this.mixOrSameRadios = this.wrapper.querySelectorAll("input[name='mix_gc_amounts']");
      this.tableWrapper = this.wrapper.querySelector('#mix-table-wrapper');
      this.sameWrapper = this.wrapper.querySelector('#same-wrapper');
      if(this.mixOrSameRadios && this.tableWrapper && this.sameWrapper){
        this.handleMixOrSame();
      }

      this.table = this.wrapper.querySelector('#mix-amounts-table tbody');
      this.addNewRow = this.wrapper.querySelector('#add-new-row');
      this.addRowLine = this.wrapper.querySelector('#add-row-line');
      this.indexRowsCounter = 3;
      if(this.table && this.addNewRow){
        this.addNewRow.addEventListener('click', () => {
          this.handleAddNewRow();
        });
      }

      this.rows = this.wrapper.querySelectorAll('tbody tr');
      if(this.rows){
        this.rows.forEach(row => {
          this.handleRowSubtotalComputing(row);
        });
      }

      this.totalMixAmount = this.wrapper.querySelector('#total-mix-gc');
      this.mixCalculationCostPackaging = this.wrapper.querySelector('#mix-calculation-cost-packaging');
      this.mixTotalCostPackaging = this.wrapper.querySelector('#mix-total-cost-packaging');

      this.billingDifferentRadios = this.wrapper.querySelectorAll("input[name='delivery_different']")
      this.deliveryAddressWrapper = this.wrapper.querySelector('#delivery-address-wrapper');
      if(this.billingDifferentRadios && this.deliveryAddressWrapper){
        this.handleDeliveryAddressVisibility();
      }

      this.gcTypeRadios = this.wrapper.querySelectorAll("input[name='gc_type']");
      this.printOptionsWrapper = this.wrapper.querySelector('#print-options-wrapper');
      this.physicalOptionsWrapper = this.wrapper.querySelector('#physical-options-wrapper');

      this.mixPackagingLine = this.wrapper.querySelector('#mix-packaging-line');
      this.samePackagingLine = this.wrapper.querySelector('#same-packaging-line');
      if(this.gcTypeRadios && this.printOptionsWrapper && this.physicalOptionsWrapper){
        this.handleOptionsVisibility();
      }

      this.numberOfGc = this.wrapper.querySelector("input[name='number_of_gc']"); //in case of same amounts
      this.amountPerGc = this.wrapper.querySelector("input[name='amount_per_gc']"); //in case of same amounts
      this.personalizeSection = this.wrapper.querySelector('#personalize-section');
      this.totalSameAmount = this.wrapper.querySelector('#total-same-gc');
      this.sameCalculationCostPackaging = this.wrapper.querySelector('#same-calculation-cost-packaging');
      this.sameTotalCostPackaging = this.wrapper.querySelector('#same-total-cost-packaging');
      if(this.personalizeSection && this.numberOfGc && this.amountPerGc){
        this.handleSameAmountsChange();
      }

      this.quoteCheckboxes = this.wrapper.querySelectorAll('.quote-checkbox');
      if(this.quoteCheckboxes){
        this.quoteCheckboxes.forEach(checkbox => {
          const text = checkbox.closest('div').querySelector('label span');
          checkbox.addEventListener('change', () => {
            if(checkbox.checked){
              text.textContent = checkbox.dataset.added;
            }
            else {
              text.textContent = checkbox.dataset.toAdd;
            }
          });
        });
      }

      const inputsNumber = this.wrapper.querySelectorAll("input[type='number']");
      if(inputsNumber){
        inputsNumber.forEach(input => {
          input.addEventListener("mousewheel", function(){ this.blur() });
          input.addEventListener("change", function(){
             if(this.value < 0) this.value = 0;
          });
        });
      }

      //Make sure every amount input is minimum GiftTable::MINIMUM_AMOUNT
      const checkAmounts = this.wrapper.querySelectorAll('.checkAmount');
      if(checkAmounts){
        checkAmounts.forEach(amount => {
          amount.addEventListener('change', () => {
            if(amount.value < Number(this.wrapper.dataset.minimumAmount)){
              amount.value = Number(this.wrapper.dataset.minimumAmount);
            }
          });
        });
      }

      this.computeTotal();
    }
  }

  handleMixOrSame(){
    const sameWrapperInputs = this.sameWrapper.querySelectorAll('input');
    this.mixOrSameRadios.forEach(radio => {
      radio.addEventListener('change', () => {
        if(radio.checked){
          if(radio.value == 'same'){
            this.tableWrapper.classList.add('hidden');
            this.sameWrapper.classList.remove('hidden');

            if(sameWrapperInputs) sameWrapperInputs.forEach(input => {input.required = true;} )

            if(this.amountPerGc.value * this.numberOfGc.value >= 500) this.personalizeSection.classList.remove('hidden');
            else this.personalizeSection.classList.add('hidden');
          }
          else {
            this.tableWrapper.classList.remove('hidden');
            this.sameWrapper.classList.add('hidden');

            if(sameWrapperInputs) sameWrapperInputs.forEach(input => {input.required = false;} )

            if(this.totalMixAmount.dataset.value >= 500) this.personalizeSection.classList.remove('hidden');
            else this.personalizeSection.classList.add('hidden');
          }
        }
      });
    });
  }

  handleAddNewRow(){
    this.addRowLine.parentNode.insertBefore(this.buildNewRow(this.indexRowsCounter), this.addRowLine);
    this.indexRowsCounter++;
  }

  buildNewRow(index){
    const row = document.createElement('tr');
    row.innerHTML = `<td class="border-l-0 border-2 border-gray-200 px-4"><input type="text" name="rows[${index}][designation]" class="w-full h-12 text-center"></td>
                    <td class="border-2 border-gray-200 px-4"><input type="number" name="rows[${index}][gc_number]" class="w-full h-12 text-center gc-number"></td>
                    <td class="border-2 border-gray-200 px-4"><input type="number" name="rows[${index}][amount]" class="w-full h-12 text-center amount"></td>
                    <td class="border-r-0 border-2 border-gray-200 px-4"> <input type="text" name="rows[${index}][subtotal]" class="w-full h-12 text-center subtotal" readonly></td>`;

    this.handleRowSubtotalComputing(row);
    return row;
  }

  handleRowSubtotalComputing(row){
    const gcNumberInput = row.querySelector('.gc-number');
    const amountInput = row.querySelector('.amount');
    const subtotal = row.querySelector('.subtotal')
    if(gcNumberInput && amountInput && subtotal){
      ['change', 'keyup'].forEach(event => {
        const rowInputs = row.querySelectorAll('input');
        gcNumberInput.addEventListener(event, () => {
          if(gcNumberInput.value) rowInputs.forEach(input => { input.required = true; })
          else rowInputs.forEach(input => { input.required = false; })

          this.computeSubtotal(gcNumberInput, amountInput, subtotal);
        });
        amountInput.addEventListener(event, () => {
          window.setTimeout(() => { //We put a little timeout here to make sure it is triggered after the checkamount listener (see above in the constructor)
            if(amountInput.value) rowInputs.forEach(input => { input.required = true; })
            else rowInputs.forEach(input => { input.required = false; })

            this.computeSubtotal(gcNumberInput, amountInput, subtotal);
          }, 50);
        });
      });
    }
  }

  computeSubtotal(gcNumberInput, amountInput, subtotal){
    if(gcNumberInput.value && amountInput.value){
      let subtotalAmount = Number(gcNumberInput.value) * Number(amountInput.value);
      subtotal.dataset.value = subtotalAmount;
      subtotal.value = Number(subtotalAmount).toLocaleString(document.body.dataset.lang.replace('_', '-'), {
        style: 'currency',
        currency: 'EUR'
      });

      this.computeTotal();
    }
  }

  computeTotal(){
    const rows = this.wrapper.querySelectorAll('tbody tr');
    let totalAmount = 0;
    let numberOfGc = 0;
    rows.forEach(row => {
      const subtotal = row.querySelector('.subtotal');
      const gcNumber = row.querySelector('.gc-number');
      if(subtotal && subtotal.dataset.value){
        totalAmount += Number(subtotal.dataset.value);
      }
      if(gcNumber && gcNumber.value){
        numberOfGc += Number(gcNumber.value);
      }
    });

    const physicalExtraFormatted = Number(this.physicalExtra).toLocaleString(document.body.dataset.lang.replace('_', '-'), {
      style: 'currency',
      currency: 'EUR'
    });
    this.mixCalculationCostPackaging.textContent = this.mixCalculationCostPackaging.dataset.text.replace('{0}', numberOfGc).replace('{1}', physicalExtraFormatted);

    const totalCostPackagingFormatted = Number(this.physicalExtra * numberOfGc).toLocaleString(document.body.dataset.lang.replace('_', '-'), {
      style: 'currency',
      currency: 'EUR'
    });
    this.mixTotalCostPackaging.textContent = totalCostPackagingFormatted;

    this.totalMixAmount.dataset.value = totalAmount;
    this.totalMixAmount.textContent = Number(totalAmount).toLocaleString(document.body.dataset.lang.replace('_', '-'), {
      style: 'currency',
      currency: 'EUR'
    });

    if(this.totalMixAmount.dataset.value >= 500) this.personalizeSection.classList.remove('hidden');
    else this.personalizeSection.classList.add('hidden');
  }

  handleDeliveryAddressVisibility(){
    const inputs = this.deliveryAddressWrapper.querySelectorAll('input:not(.ignore), select:not(.ignore)');
    this.billingDifferentRadios.forEach(radio => {
      radio.addEventListener('change', () => {
        if(radio.checked){
          if(radio.value === 'delivery_same'){
            this.deliveryAddressWrapper.classList.add('hidden');
            if(inputs) inputs.forEach(input => {input.required = false;});
          }
          else {
            this.deliveryAddressWrapper.classList.remove('hidden');
            if(inputs) inputs.forEach(input => {input.required = true;});
          }
        }
      });
    });
  }

  handleSameAmountsChange(){
    const inputs = [this.amountPerGc, this.numberOfGc];
    const events = ['change', 'keyup'];
    inputs.forEach(input => {
      events.forEach(event => {
        input.addEventListener(event, () => {
          window.setTimeout(() => {
            const physicalExtraFormatted = Number(this.physicalExtra).toLocaleString(document.body.dataset.lang.replace('_', '-'), {
              style: 'currency',
              currency: 'EUR'
            });
            this.sameCalculationCostPackaging.textContent = this.sameCalculationCostPackaging.dataset.text.replace('{0}', this.numberOfGc.value ? this.numberOfGc.value : 0).replace('{1}', physicalExtraFormatted);

            const totalCostPackagingFormatted = Number(this.physicalExtra * this.numberOfGc.value).toLocaleString(document.body.dataset.lang.replace('_', '-'), {
              style: 'currency',
              currency: 'EUR'
            });
            this.sameTotalCostPackaging.textContent = totalCostPackagingFormatted;

            this.totalSameAmount.dataset.value = this.amountPerGc.value * this.numberOfGc.value;
            this.totalSameAmount.textContent = Number(this.amountPerGc.value * this.numberOfGc.value).toLocaleString(document.body.dataset.lang.replace('_', '-'), {
              style: 'currency',
              currency: 'EUR'
            });

            if(this.amountPerGc.value * this.numberOfGc.value >= 500) this.personalizeSection.classList.remove('hidden');
            else this.personalizeSection.classList.add('hidden');
          }, 50);
        });
      });
      input.dispatchEvent(new Event('change'));
    });
  }

  handleOptionsVisibility(){
    this.gcTypeRadios.forEach(radio => {
      radio.addEventListener('change', () => {
        if(radio.checked){
          if(radio.value === 'print'){
            this.printOptionsWrapper.classList.remove('hidden');
            this.physicalOptionsWrapper.classList.add('hidden');
            this.mixPackagingLine.classList.add('hidden');
            this.samePackagingLine.classList.add('hidden');
          }
          else {
            this.printOptionsWrapper.classList.add('hidden');
            this.physicalOptionsWrapper.classList.remove('hidden');
            this.mixPackagingLine.classList.remove('hidden');
            this.samePackagingLine.classList.remove('hidden');
          }
        }
      });
    });
  }

}

export default GiftQuote;
